import { render, staticRenderFns } from "./RecentlyVisitedList.vue?vue&type=template&id=4997baf6&scoped=true&"
import script from "./RecentlyVisitedList.vue?vue&type=script&lang=js&"
export * from "./RecentlyVisitedList.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyVisitedList.vue?vue&type=style&index=0&id=4997baf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997baf6",
  null
  
)

export default component.exports